import { render, staticRenderFns } from "./AveineQuizImport.vue?vue&type=template&id=4d72bd0c"
import script from "./AveineQuizImport.vue?vue&type=script&lang=js"
export * from "./AveineQuizImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports